import { Box, styled } from '@mui/material';

export const Circle = styled(Box, {
  shouldForwardProp : (prop) => prop !== 'size' && prop !== 'color',
})(({ size, color }) => ({
  width           : size,
  height          : size,
  borderRadius    : size,
  backgroundColor : color,
}));
